import { render, staticRenderFns } from "./LotFormatModal.vue?vue&type=template&id=1d8d7744&scoped=true"
import script from "./LotFormatModal.vue?vue&type=script&lang=js"
export * from "./LotFormatModal.vue?vue&type=script&lang=js"
import style0 from "./LotFormatModal.vue?vue&type=style&index=0&id=1d8d7744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8d7744",
  null
  
)

export default component.exports